import axios from "axios";
import io from "socket.io-client";

export const getNewsFeedLunchUrl = async (params) => {
    try {
        if (params) {
            const customHeaders = {
                "clientid": params.newsFeedClientId,
                "clientsecret": params.newsFeedClientSecret
            };

            const postParams = {
                "userId": params.userId,
                "role": params.role,
                "tenantId": params.newsFeedTenantId,
                "mykademyOrganisationDomain": params.mykademyOrganisationDomain,
                "mykademyAuthorization": params.mykademyAuthorization,
                "mykademyAccessToken": params.mykademyAccessToken,
                "mykademyOrganisationURL": params.mykademyOrganisationURL,
                "useAPI": "use-as-api"
            }
            
            const response = await axios.post(params.newsFeedBaseUrl, postParams, {
                headers: {
                'Content-Type': 'application/json',
                ...customHeaders
                }
            });
            return response.data;
        }
    } catch (error) {
        return error;
    }
}

export const getNewsFeeds = async (params) => {
    let page;
    if (params && params.page) {
        page = 'page=' + params.page + '&';
    } else {
        page = '';
    }
    try {
        const response = await axios.get(`https://${params.newsFeedApiUrl}/api/thirdparty/news-feeds?${page}${params.newsFeedUrl}`, {
            headers: {
              'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getComments = async (params) => {
    let currentPage = params.currentPage !== undefined ? params.currentPage : 1;
    try {
        const response = await axios.get(`https://${params.newsFeedApiUrl}/api/thirdparty/news-feed-client/${params.id}/comments?page=${currentPage}&${params.newsFeedLunchUrl}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const likeOnComment = async (params) => {
    try {
        const response = await axios.post(`https://${params.newsFeedApiUrl}/api/thirdparty/news-feed/comment/${params.commentID}/like?${params.newsFeedLunchUrl}`, {
            newsFeedClientId: params.newsFeedClientId,
        },{headers: { 'Content-Type': 'application/json' }})
        return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const showReplyComments = async (params) => {
    try {
        const response = await axios.get(`https://${params.newsFeedApiUrl}/api/thirdparty/news-feed/comment/${params.commentID}/replies?${params.newsFeedLunchUrl}`, {
            headers: { 
                'Content-Type': 'application/json' 
            }
        });
        return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const replyComment = async (params) => {
    try {
        const response = await axios.post(`https://${params.newsFeedApiUrl}/api/thirdparty/news-feed/comment/${params.commentID}/reply?${params.newsFeedLunchUrl}`, {
            replyDescription: params.replyDescription, newsFeedClientId: params.newsFeedClientId,
        },{
            headers: { 
                'Content-Type': 'application/json' 
            }
        });
        return response.data;
    } catch (error) {
      console.log(error);
    }
}

let socket = null;
export const Global = {
    getSocket: () => {
      if (!socket) {
        socket = io(process.env.REACT_APP_NEWS_API_URL, {
          transports: ['websocket'],
        });
      }
      return socket;
    },
};